import { MouseEventHandler } from "react";
import "./style.css";
import { ReactNode } from "react";
import { Tooltip } from "@progress/kendo-react-tooltip";

export interface ButtonProps {
    onClick?: MouseEventHandler<HTMLSpanElement>;
    iconName?: string;
    additionalClass?: string;
    title?: string;
    text?: ReactNode;
    preset?: "default" | "fill" | "bordered" | "successBtn" | "trashBin" | "light" | "bordered_image";
    image?: string;
    imageStyle?: string;
    disabled?: boolean;
    tooltip?: string;
    isLoading?: boolean
}

export const PRESETS = {
    default: "./style.css",
    fill: "fill",
    bordered: "bordered",
    successBtn: "successBtn",
    trashBin: "trashBin",
    light: "light",
    bordered_image:'bordered_image'
};

function NoteneticButton(props: ButtonProps) {
    const { onClick, additionalClass, text, preset, iconName, image, imageStyle, title, disabled = false, tooltip, isLoading, ...others } = props;

    return (<>
       { tooltip?
        <Tooltip anchorElement="target" position="top">
            <button
                className={`${preset ? PRESETS[preset] : PRESETS['default']} ${additionalClass ?? ''}`}
                onClick={onClick}
                title={tooltip || title}
                disabled={disabled}
            >
                {isLoading ? (
                    <div
                        className="spinner-border text-dark spinner-sm"
                        role="status"
                    >
                        <span className="sr-only">Loading...</span>
                    </div>
                ) :
                    <>
                        {iconName && <i className={iconName}></i>}
                        {image &&
                            <img
                                src={image}
                                className={imageStyle}
                                style={{ maxWidth: "15px", marginBottom: "4px" }}
                            />
                        }
                        {text && <span className="pl-1">{text}</span>}
                    </>
                }
            </button>
        </Tooltip>:
         <button
         className={preset ? PRESETS[preset] : PRESETS['default'] + additionalClass}
         onClick={onClick}
         title={title}
         disabled={disabled}
     >
         {iconName && <i className={iconName}></i>}
         {image &&
             <img
                 src={image}
                 className={imageStyle}
                 style={{ maxWidth: "15px", marginBottom:"4px" }}
             />
         }
         {text && <span className="pl-1">{text}</span>}
     </button>}</>
    );
}

export default NoteneticButton;
